import React, { useEffect, useState } from "react";
import { Slider } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const PrettoSlider = withStyles({
  root: {
    color: "#01a9f4",
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
    top: -22,
    "& *": {
      background: "transparent",
      color: "#000",
    },
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

export function CustomSlider({ min, max, onChange, step, reset }) {
  const [value, setValue] = useState(min);
  useEffect(() => {
    setValue(min);
  }, [reset, min]);

  const handleSliderChange = (event, newValue) => {
    onChange(event, newValue);
  };

  return (
    <PrettoSlider
      valueLabelDisplay="on"
      aria-label="pretto slider"
      min={min}
      max={max}
      value={value}
      defaultValue={min}
      marks
      step={step}
      onChangeCommitted={handleSliderChange}
      onChange={(event, newValue) => setValue(newValue)}
    />
  );
}
